import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Space } from 'antd';
import './selectLocale.css';

export default class SelectLanguage extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
  };

  localeButton = (locale, title) => {
    const { onClick, locale: selectedLocale } = this.props;
    return (
      <Button
        type="link"
        onClick={() => onClick(locale)}
        className={selectedLocale === locale ? null : 'inactive'}
      >
        {title}
      </Button>
    );
  };

  render() {
    return (
      <Space className="select-locale">
        {this.localeButton('et', 'Eesti keel')}
        {this.localeButton('en', 'English')}
      </Space>
    );
  }
}
